import React, { useEffect, useState, useContext } from "react";
import { useParams, Link } from "react-router-dom";
import { buildAuthorPath, buildPublicationPath, buildPublisherPath } from "../../utils/slugify";
import axiosInstance from "../../services/axiosInstance";
import {
    Modal, Button, Accordion,
    AccordionItem,
    AccordionHeader,
    AccordionBody,
    Card,
    CardBody, Spinner
} from "react-bootstrap";
import CourseHeader from "../header2/index-two";
import { Footer2 } from "../footer2/index";
import { AppContext } from "../../services/AuthContext";
import { publicationdetail, publicationSuggestion } from "../../services/publicationService";
import usePageTracking from "../../hooks/usePageTracking";
import { Chapter, Chart, Cloud, Icon1, Icon2, Import, Key, Mobile, People, Play, Teacher, Timer2, User1, Users, Video, Video2, Timer } from "../imagepath";
import { publisherDetail } from "../../services/publisherService";
import PreviousIssues from "../pages/course/courseDetails/PreviousIssues";
const JournalDetail = () => {
    usePageTracking("journal-detail");
    const { id } = useParams();
    const { auth } = useContext(AppContext);

    const [journal, setJournal] = useState(null);
    const [parentDetails, setParentDetails] = useState({});
    const [similarJournals, setSimilarJournals] = useState([]);
    const [availableLanguages, setAvailableLanguages] = useState([]);
    const [activeTab, setActiveTab] = useState("tr");
    const [showModal, setShowModal] = useState(false);
    const [citationFormat, setCitationFormat] = useState("");
    const [subPublications, setSubPublications] = useState([]);
    const [loading, setLoading] = useState(true);
    const [publisherDetails, setPublisherDetails] = useState([]);

    useEffect(() => {
        const fetchJournalDetails = async () => {
            setLoading(true);
            try {
                const data = await publicationdetail(id, auth.token);
                const journalData = data.data.elasticjson;
                setJournal(journalData);
                setSubPublications(data.data.subPublications)
                setAvailableLanguages(
                    Array.from(
                        new Set([
                            ...journalData.templateInfo.flatMap((info) =>
                                info.value
                                    ?.filter(
                                        (val) =>
                                            val.lang &&
                                            Array.isArray(val.value) &&
                                            val.value.some((v) => typeof v === "string" && v.trim() !== "")
                                    )
                                    ?.map((val) => val.lang)
                            ),
                            ...journalData.publicationtypeInfo.flatMap((info) =>
                                info.value
                                    ?.filter(
                                        (val) =>
                                            val.lang &&
                                            Array.isArray(val.value) &&
                                            val.value.some((v) => typeof v === "string" && v.trim() !== "")
                                    )
                                    ?.map((val) => val.lang)
                            ),
                        ])
                    )
                );

                setActiveTab("tr");
            } catch (error) {
                console.error("Error fetching journal details:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchJournalDetails();
    }, [id, auth.token]);

    useEffect(() => {
        if (!journal || !journal.publishers) return;

        journal.publishers.forEach(async (publisher) => {
            try {
                const publisherId = publisher.mysqlId;
                if (publisherId) {
                    const response = await publisherDetail(publisherId, 1, auth.token);
                    setPublisherDetails((prev) => ({
                        ...prev,
                        [publisherId]: response.data,
                    }));
                }
            } catch (err) {
                console.error("Error fetching publisher detail:", err);
            }
        });
    }, [journal, auth.token]);

    useEffect(() => {
        if (journal) {
            const fetchSimilarJournals = async () => {
                try {
                    const suggestions = await publicationSuggestion(auth.token, {
                        title:
                            journal.publicationtypeInfo.find(
                                (attr) => attr.attributename === "Başlık"
                            )?.value.find((val) => val.lang === "tr")?.value[0] || "",
                        summary:
                            journal.publicationtypeInfo.find(
                                (attr) => attr.attributename === "Özet"
                            )?.value.find((val) => val.lang === "tr")?.value[0] || "",
                        keywords:
                            journal.publicationtypeInfo.find(
                                (attr) => attr.attributename === "Anahtar Kelimeler"
                            )?.value.find((val) => val.lang === "tr")?.value?.join(", ") ||
                            "",
                        publicationid: journal.mysqlId,
                        publicationtype: journal.publicationtype,
                    });
                    setSimilarJournals(suggestions?.data || []);
                } catch (error) {
                    console.error("Error fetching similar journals:", error);
                }
            };

            fetchSimilarJournals();
        }
    }, [auth.token, journal]);

    const renderCitation = () => {
        if (!journal) return "Lütfen format seçiniz.";
        const title =
            journal.publicationtypeInfo?.find(
                (attr) => attr.attributename === "Başlık"
            )?.value.find((val) => val.lang === activeTab)?.value[0] || "";
        const authors = journal?.authors
            ?.map((author) => `${author.name} ${author.surname}`)
            .join(", ");
        const year =
            journal?.publicationtypeInfo?.find(
                (attr) => attr.attributename === "Yayın Tarihi"
            )?.value.find((val) => val.lang === activeTab)?.value[0]?.split(" ")[0] ||
            "";

        if (citationFormat === "apa") {
            return `${authors}. (${year}). ${title}.`;
        }

        return "Geçerli format seçilmedi.";
    };

    const [openItem, setOpenItem] = useState(0);

    const toggleItem = (id) => {
        setOpenItem((prev) => (prev === id ? id : id));
    };

    if (loading) {
        return <div className="text-center">
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Yükleniyor...</span>
            </Spinner>
        </div>
    }

    return (
        <>
            <CourseHeader activeMenu={"JournalDetail"} />
            <div className="breadcrumb-bar ">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-12">

                        </div>
                    </div>
                </div>
            </div>

            <div className="main-wrapper">
                <section className="page-content course-sec">
                    <div className="container">
                        <div className="card feature-sec">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-md-3">
                                        <img
                                            src={
                                                journal?.coverimage
                                                    ? `https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${journal.mysqlId}/${journal.coverimage}`
                                                    : Video
                                            }
                                            alt="Dergi Kapağı"
                                            className="img-fluid"
                                        />
                                    </div>
                                    <div className="col-md-9">
                                        <ul className="nav nav-tabs">
                                            {availableLanguages.map((lang) => (
                                                <li className="nav-item" key={lang}>
                                                    <button
                                                        className={`nav-link ${activeTab === lang ? "active" : ""
                                                            }`}
                                                        onClick={() => setActiveTab(lang)}
                                                    >
                                                        {lang.toUpperCase()}
                                                    </button>
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="tab-content mt-3">
                                            <h5 className="subs-title" style={{ fontSize: "25px" }}>
                                                {journal?.publicationtypeInfo?.find(
                                                    (attr) => attr.attributename === "Başlık"
                                                )?.value.find((val) => val.lang === activeTab)?.value[0] ||
                                                    "-"}
                                            </h5>
                                            <p>
                                                {journal?.templateInfo?.find(
                                                    (attr) => attr.attributename === "Özet"
                                                )?.value.find((val) => val.lang === activeTab)?.value[0] ||
                                                    ""}
                                                {journal?.publicationtypeInfo?.find(
                                                    (attr) => attr.attributename === "Özet"
                                                )?.value.find((val) => val.lang === activeTab)?.value[0] ||
                                                    ""}
                                                {journal?.templateInfo?.find(
                                                    (attr) => attr.attributename === "Dergi Hakkında"
                                                )?.value.find((val) => val.lang === activeTab)?.value[0] ||
                                                    ""}
                                                {journal?.publicationtypeInfo?.find(
                                                    (attr) => attr.attributename === "Dergi Hakkında"
                                                )?.value.find((val) => val.lang === activeTab)?.value[0] ||
                                                    ""}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="card feature-sec mt-4">
                            <div className="card-header">
                                <h5 className="subs-title" style={{ margin: "0" }}>Dergi Hakkında</h5>
                            </div>
                            <div className="card-body">
                                <ul className="list-unstyled">
                                    {/* Eser Adı */}
                                    <li>
                                        <b>Eser Adı:</b>{" "}
                                        {
                                            journal?.publicationtypeInfo?.find(
                                                (attr) => attr.attributename === "Başlık"
                                            )?.value.find((val) => val.lang === "tr")?.value[0] || "-"
                                        }
                                    </li>

                                    {/* Eser Adı (İkinci Dil) */}
                                    <li>
                                        <b>Eser Adı (İkinci Dil):</b>{" "}
                                        {
                                            journal?.publicationtypeInfo?.find(
                                                (attr) => attr.attributename === "Başlık"
                                            )?.value.find((val) => val.lang === "en")?.value[0] || "-"
                                        }
                                    </li>

                                    {/* Dil */}
                                    <li>
                                        <b>Dil:</b>{" "}
                                        {[
                                            ...new Set(
                                                journal?.publicationtypeInfo?.find((attr) => attr.attributename === "Yayın Dili")
                                                    ?.value.map((val) => val.value[0]) || []
                                            ),
                                        ].join(", ") || "-"}
                                    </li>

                                    <li>
                                        <b>Editör:</b>{" "}
                                        {journal?.authors?.length > 0 ? (
                                            journal.authors.map((author, index) => (
                                                <React.Fragment key={author.mysqlId}>
                                                    <Link to={buildAuthorPath({ name: author.name, surname: author.surname, id: author.mysqlId })}>
                                                        {`${author.name} ${author.surname}` || "Bilinmeyen Editör"}
                                                    </Link>
                                                    {index < journal.authors.length - 1 && ", "}
                                                </React.Fragment>
                                            ))
                                        ) : (
                                            "-"
                                        )}
                                    </li>

                                    <li>
                                        <b>Yayıncı:</b>{" "}
                                        {journal?.publishers?.length > 0 ? (
                                            journal.publishers.map((publisher, index) => {
                                                const pubId = publisher.mysqlId;
                                                const details = publisherDetails[pubId];

                                                return (
                                                    <React.Fragment key={pubId}>
                                                        <Link to={buildPublisherPath({ title: details?.title || publisher.title, id: pubId })}>
                                                            {details?.title || publisher.title || "Bilinmeyen Yayıncı"}
                                                        </Link>
                                                        {index < journal.publishers.length - 1 && ", "}
                                                    </React.Fragment>
                                                );
                                            })
                                        ) : (
                                            "-"
                                        )}
                                    </li>


                                    {/* ISSN */}
                                    <li>
                                        <b>ISBN:</b>{" "}
                                        {
                                            journal?.publicationtypeInfo?.find(
                                                (attr) => attr.attributename === "ISBN"
                                            )?.value.find((val) => val.lang === "tr")?.value[0] || "-"
                                        }
                                    </li>

                                    {/* eISSN */}
                                    <li>
                                        <b>E-ISBN:</b>{" "}
                                        {
                                            journal?.publicationtypeInfo?.find(
                                                (attr) => attr.attributename === "E-ISBN"
                                            )?.value.find((val) => val.lang === "tr")?.value[0] || "-"
                                        }
                                    </li>

                                    {/* Yayın Sıklığı */}
                                    <li>
                                        <b>Yayın Sıklığı:</b>{" "}
                                        {
                                            journal?.templateInfo?.find(
                                                (attr) => attr.attributename === "Periyot"
                                            )?.value.find((val) => val.lang === "tr")?.value[0] || "-"
                                        }
                                    </li>

                                    {/* Web Sitesi */}
                                    <li>
                                        <b>Web Sitesi:</b>{" "}
                                        {journal?.templateInfo?.find(
                                            (attr) => attr.attributename === "Web Adresi"
                                        )?.value.find((val) => val.lang === "tr")?.value[0] ? (
                                            <a
                                                href={
                                                    journal?.templateInfo?.find(
                                                        (attr) => attr.attributename === "Web Adresi"
                                                    )?.value.find((val) => val.lang === "tr")?.value[0]
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                {
                                                    journal?.templateInfo?.find(
                                                        (attr) => attr.attributename === "Web Adresi"
                                                    )?.value.find((val) => val.lang === "tr")?.value[0]
                                                }
                                            </a>
                                        ) : (
                                            "-"
                                        )}
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <PreviousIssues
                            publicationId={id}
                            publicationType={journal?.publicationtype}
                        />





                        <div className="card feature-sec">
                            <div className="card-header">
                                <h5 className="subs-title" style={{ marginBottom: "0px" }}>Benzer Dergiler</h5>
                            </div>
                            <div className="card-body">
                                <ul>
                                    {similarJournals?.map((pub, index) => {
                                        const publicationTitle =
                                            pub?.publicationtypeInfo.find((attr) => attr.attributename === "Başlık")?.value[0]?.value[0] ||
                                            pub?.templateInfo.find((attr) => attr.attributename === "Başlık")?.value[0]?.value[0] ||
                                            "-";

                                        const authors = pub?.authors || [];

                                        return (
                                            <li key={index} className="d-flex align-items-center mb-3">
                                                {/* Kitap Kapağı */}
                                                <img
                                                    src={
                                                        pub?.coverimage
                                                            ? `https://idealonline.com.tr/service/idealonline/v1/publications/search/displayFile/${pub?.mysqlId}/${pub?.coverimage}`
                                                            : Video
                                                    }
                                                    alt={publicationTitle}
                                                    className="me-2"
                                                    style={{
                                                        width: "50px",
                                                        height: "50px",
                                                        objectFit: "cover",
                                                        borderRadius: "5px",
                                                    }}
                                                />
                                                <div>
                                                    <Link className="subs-title" to={buildPublicationPath({ title: publicationTitle, id: pub?.mysqlId })} style={{ fontWeight: "bold" }}>
                                                        {publicationTitle}
                                                    </Link>
                                                    {authors.length > 0 && (
                                                        <p className="mb-0">
                                                            <b>Yazarlar:</b>{" "}
                                                            {authors.map((author, i) => (
                                                                <React.Fragment key={author.mysqlId}>
                                                                    <Link to={buildAuthorPath({ name: author.name, surname: author.surname, id: author.mysqlId })}>
                                                                        {author.name} {author.surname}
                                                                    </Link>
                                                                    {i < authors.length - 1 && ", "}
                                                                </React.Fragment>
                                                            ))}
                                                        </p>
                                                    )}
                                                </div>
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Alıntı Modal */}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Alıntı</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <select
                            className="form-select mb-3"
                            value={citationFormat}
                            onChange={(e) => setCitationFormat(e.target.value)}
                        >
                            <option value="">Format Seçiniz</option>
                            <option value="apa">APA</option>
                            {/* Diğer formatlar */}
                        </select>
                        <pre>{renderCitation()}</pre>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="secondary"
                            onClick={() =>
                                navigator.clipboard.writeText(renderCitation())
                            }
                        >
                            Kopyala
                        </Button>
                        <Button variant="danger" onClick={() => setShowModal(false)}>
                            Kapat
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
            <Footer2 />
        </>
    );
};

export default JournalDetail;
